/* @flow */
export default {
  DATE_FORMAT: '{{timestamp, date}}',
  DATETIME_FORMAT: '{{timestamp, datetime}}',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  NAME: 'Name',
  NOTES: 'Notes',
  USERNAME: 'Username',
  DESCRIPTION: 'Description',
  PASSWORD: 'Password',
  LOGIN: 'Sign in',
  FORGOT_PASSWORD: 'Forgot password...',
  LOADING: 'Loading',
  NO_VALUE_AVAILABLE: 'No value available',
  NO_VALUE: 'No value',
  SHOW_MORE: 'Show more...',
  SELECT_A_VALUE: 'Select a value...',
  PRODUCTION_NAME: 'Production name',
  EDITION: 'Edition',
  AREA: 'Area',
  PRODUCER_NAME: 'Producer name',
  CHANNEL: 'Channel',
  BROADCASTER: 'Broadcaster',
  PLATFORM_CHANNEL: 'Platform channel',
  BROADCAST_TYPE: 'Broadcast type',
  PRODUCTION_TYPE: 'Production type',
  USAGE_TYPE: 'Usage type',
  PRODUCTION: 'Production',
  EPISODE: 'Episode',
  START_LICENSE_DATE: 'Start license date',
  END_LICENSE_DATE: 'End license date',
  TERRITORY: 'Territory',
  PUBLISHER_OR_DISTRIBUTOR: 'Publisher or distributor',
  QUANTITY_SUPPORT: 'Quantity (media/episodes)',
  DISTRIBUTION_CHANNEL_OR_MEDIA: 'Distribution channel or media',
  LOAD_PRESET: 'Load preset',
  USAGE_QUANTITY: 'Quantity (media/episodes)',
  CART: 'Cart',
  EMPTY_CART: 'Empty cart',
  TRACK: 'Track',
  TRACKS: 'Tracks',
  TOTAL_PRICE_ELEMENTS: 'Total price of purchasable elements',
  DISCOUNTS_OR_INCREASES: 'Discounts or surcharges',
  NET_PRICE_ELEMENTS: 'Net price of selected elements',
  BUY: 'Purchase',
  IN_CART: 'In cart',
  SEARCH_SUPPORTS: 'Search media',
  SEARCH_TRACKS: 'Search tracks',
  SEARCH_SERVICES: 'On Demand services',
  NEWS: 'News',
  SMARTLISTS: 'Smartlists',
  FEATURED: 'Featured',
  ON_DEMAND: 'On Demand',
  ON_DEMAND_SERVICES: 'On Demand services',
  SUPPORTS: 'Media',
  LOGOUT: 'Logout',
  PURCHASE_HISTORY: 'Purchase history',
  WORKLIST: 'Worklist',
  USAGE: 'Usage',
  PRODUCTIONS: 'Productions',
  PROFILE: 'Profile',
  PROFILE_SETTINGS: 'Settings',
  REPORT: 'Report',
  INFO: 'Info',
  PRICE_LISTS: 'Price lists',
  TUTORIAL: 'Tutorial',
  HELP: 'Help',
  SESSION_USAGE: 'Session usage',
  CATEGORIES: 'Categories',
  UNKNOWN_ARTIST: 'Unknown artist',
  SELECT_A_WL1: 'Select a Worklist 1',
  SELECT_A_WL2: 'Select a Worklist 2',
  SELECT_A_SESSION_USAGE: 'Select a session usage',
  TRACK_NOT_DOWNLOADABLE:
    'Unable to start downloading, the appropriate license components must be purchased first',
  PERFORMER: 'Performer',
  PERFORMERS: 'Performers',
  SUPPORT_TITLE: 'Medium title',
  TITLE: 'Title',
  TITLES: 'Titles',
  PEOPLE: 'People',
  TAG: 'Tag',
  AUTHOR: 'Author',
  AUTHORS: 'Authors',
  TAGS: 'Tags',
  EDITORS: 'Editors',
  LABEL: 'Label',
  YEAR: 'Year',
  RESET_FILTERS: 'Reset filters',
  PRODUCTION_DESCRIPTION: 'Production description',
  DEFINE_NEW_PRODUCTION: 'Define new production',
  DEFINE_NEW_USAGE: 'Define new usage',
  SELECT_AS_USAGE_SESSION: 'Select as Session usage',
  USAGE_DESCRITPION: 'Usage description',
  ARE_YOU_SURE: 'Are you sure?',
  SELECTED_AS_WL1: 'Selected as Worklist 1',
  SELECTED_AS_WL2: 'Selected as Worklist 2',
  SELECT_AS_WL1: 'Select as Worklist 1',
  SELECT_AS_WL2: 'Select as Worklist 2',
  DEFINE_NEW_WORKLIST: 'Define new worklist',
  SEARCH: 'Search',
  GENERIC_ERROR: 'Generic error',
  NO_RESULT: 'No result',
  NO_ARTIST: 'No artist',
  YOU_SEARCHED: 'You searched',
  ANY: 'Any',
  SORTED_BY: 'Sorted by',
  YOU_HAVE_FOUND: 'You have found',
  ONE_SUPPORT: 'One medium',
  ONE_NEWS: 'One news',
  SUPPORT: 'Medium',
  NO_PERFORMER: 'No performer',
  NO_AUTHOR: 'No author',
  PLAYING: 'Playing',
  PAUSE: 'Pause',
  PLAY: 'Play',
  ALBUM_COVER: 'Album cover',
  OPERA: 'Opera',
  CATALOG: 'Catalog',
  METRE: 'Metre',
  TEMPO: 'Tempo',
  ORCHESTRATION: 'Orchestration',
  BPM: 'BPM',
  GENRE: 'Genre',
  TONES: 'Tones',
  ANY_TRACK: 'Any track',
  ALL_CATEGORIES: 'All categories',
  IN_CATEGORIES: 'In categories',
  ONE_TRACK: 'One track',
  QUOTATION: 'Quotation',
  SMARTLIST: 'Smartlist',
  DATE: 'Date',
  ONDEMAND_TYPE: 'Request type',
  TRACK_TITLE: 'Track title',
  REQUEST_TITLE: 'Request title',
  QUOTATION_TITLE: 'Quotation title',
  SMARTLIST_TITLE: 'Smartlist title',
  SUBMIT: 'Submit',
  WORKLISTS: 'Worklists',
  ELEMENTS: 'Elements',
  MODIFIED_DATE: 'Modified date',
  WORKLIST_COVER: 'Worklist cover',
  WRITE_REQUEST: 'Write a request',
  CREATE_DATE: 'Create date',
  ITEMS_COUNT: 'Items count',
  USAGE_TAB_1: 'Review',
  USAGE_TAB_2: 'License',
  USAGE_TAB_3: 'Notes',
  EXCLUSIVE: 'Exclusive',
  NO_PRODUCTION_TYPE: 'No production type',
  NO_USAGE_TYPE: 'No usage type',
  NO_BROADCAST_TYPE: 'No broadcast type',
  NO_PRODUCTION: 'No production',
  NO_EPISODE: 'No episode',
  NO_PLATFORM: 'No platform',
  NO_START_LICENSE_DATE: 'No start license date',
  NO_END_LICENSE_DATE: 'No end license date',
  YES: 'Yes',
  NO: 'No',
  EMPTY_WORKLIST: 'Empty worklist',
  DETAILS: 'Details',
  PUBLISH: 'Publish',
  ARCHIVE: 'Archive',
  DELETE: 'Delete',
  NO_OPTIONS_AVAILABLE: 'No options available',
  NO_OPTION_SELECTED: 'No option selected',
  EXCLUDE_PRODUCTION_MUSIC: 'Exclude Production music',
  MORE_TRACKS: 'More tracks...',
  RELEVANCE: 'Relevance',
  DURATION: 'Duration',
  PRICE: 'Price',
  ALBUM: 'Album',
  SINGLES: 'Singles',
  COMPILATION: 'Compilation',
  SOUNDTRACK: 'Soundtrack',
  PRODUCTION_MUSIC: 'Production Music',
  CLASSIC_MUSIC: 'Classic Music',
  DANCE_MUSIC: 'Electronic Music',
  NO_PURCHASES: 'No purchases',
  SAVE_AS_PRESET: 'Save as preset',
  NO_TRACK_TO_PLAY: 'No track to play',
  SHOW_PLAYLIST: 'Show playlist',
  CREATE_NEW_PRODUCTION: 'Create new production',
  USAGE_NAME: 'Usage name',
  USAGE_PRESET_NAME: 'Usage preset name',
  NO_DESCRIPTION: 'No description',
  ASK_NEW_SMARTLIST: 'Ask new smartlist',
  ASK_NEW_TRACK: 'Ask new track',
  ASK_QUOTATION: 'Ask quotation',
  PURCHASE_DATE: 'Purchase date',
  CONFIRM_EXIT_DIRTY_FORM:
    'You are about to change page but you may have unsaved work. Do you want to proceed?',
  EXCLUSIVE_NOTES: 'Exclusive notes',
  NEW_WORKLIST: 'new worklist',
  ADD_TO: 'Add to',
  DOWNLOAD: 'Download',
  RESET: 'Reset',
  LICENSE_COMPONENTS: 'License components',
  RIGHT: 'Right',
  DISCOUNTED_PRICE: 'Discounted price',
  TOTAL_PRICE_PURCHASED_ELEMENTS: 'Total price of purchased elements',
  SENT_TO_CART_DATE: 'Sent to cart date',
  NO_COMPONENTS: "Cannot compute relative license components with current usage's settings",
  CATEGORY: 'Category',
  GO_TO_WORKLIST: 'Go to worklist',
  BASES: 'Bases',
  CANNOT_BUY: 'Cannot purchase',
  USAGE_DETAILS: 'Usage details',
  I_CONSENT: 'I consent',
  COOKIE_BANNER: 'This website uses cookies to enhance the user experience.',
  DEMO: 'Demo',
  LEGAL_OFFICE: 'Legal office',
  REGISTERED_CAPITAL: 'Registered capital',
  LEGAL_NOTES: 'Legal notes',
  PURCHASE_MISSING_COMPONENTS:
    "A license component was not sent to Cart because it doesn't have a price yet",
  COLLECTING: 'Collecting',
  COMING_SOON: 'Coming soon',
  TRY_SMARTLISTS: 'Try the thematic collections that experienced operators prepare for you!',
  FILTERS: 'Filters',
  CREATE: 'Create',
  NO_USAGE_PRESETS_AVAILABLE: 'No usage preset available',
  NO_USAGE_PRESET_SELECTED: 'Select a usage preset to use',
  USE_SEARCH_HELPER_1: 'To perform a search you can use the search bar',
  USE_SEARCH_HELPER_2: 'at the top of the page',
  EDIT: 'Edit',
  LOCKED: 'Locked',
  UNLOCKED: 'Unlocked',
  PREVIOUS_TRACK: 'Previous track',
  NEXT_TRACK: 'Next track',
  PAUSED: 'Paused',
  MUTE_VOLUME: 'Mute volume',
  UNMUTE_VOLUME: 'Unmute volume',
  ASK_REQUEST: 'Ask a request',
  REFRESH: 'Refresh',
  ADD: 'Add',
  COLLAPSE: 'Collapse',
  EXPAND: 'Expand',
  SEARCH_TITLES: 'Search for titles',
  SEARCH_TAGS: 'Search for tags',
  SEARCH_PEOPLE: 'Search for people',
  SHOW_LESS: 'Show less',
  USAGE_PRESETS: 'Usage presets',
  CREATE_NEW_USAGE_PRESET: 'Create a new usage preset',
  COPY_AS_USAGE_PRESET: 'Copy this usage as a usage preset',
  SELECT_THIS_USAGE_PRESET: 'Select this usage preset',
  SELECT_A_USAGE_PRESET: 'Click to select a usage preset',
  MUSIC_BASES: 'Music bases',
  YOU_SEARCHED_QUERY:
    '{{resultsCount}} {{resultsType}} for "{{searchString}}", sorted by {{ordering}}, in {{categories}} and',
  SEND_TO_WORKLIST_BEFORE_BUY: 'To purchase, save the item in a Worklist first',
  ITEMS_TO_CHECKOUT_NEED_USAGE:
    'There are items ready for checkout but a usage type must be defined',
  DO_YOU_CONFIRM_PURCHASE: 'The selected items will be purchased. Do you want to proceed?',
  YOU_SEARCHED_NEWS: '{{resultsCount}} {{resultsType}} in {{categories}}',
};
